import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

function buildParams(obj) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined && v !== null && v !== '') params.set(k, v);
  }
  const str = params.toString();
  return str ? `?${str}` : '';
}

/**
 * Liste paginée des commandes Shopify.
 * Filtres : from, to, financial_status, q (num/email), sku, page, per_page.
 */
export function useShopifyOrders({ from, to, financial_status, q, sku, page = 1, per_page = 50 } = {}) {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['shopify-orders', 'list', scopeKey, { from, to, financial_status, q, sku, page, per_page }],
    queryFn: () =>
      api.get(`/shopify/orders${buildParams({ from, to, financial_status, q, sku, page, per_page })}`),
    staleTime: 60_000,
    enabled: scopeKey !== 'loading',
  });
}

/**
 * Détail d'une commande Shopify avec ses line items enrichis (LEFT JOIN products).
 */
export function useShopifyOrder(id) {
  const scopeKey = useScopeKey();
  return useQuery({
    queryKey: ['shopify-orders', 'detail', scopeKey, id],
    queryFn: () => api.get(`/shopify/orders/${id}`),
    staleTime: 60_000,
    enabled: scopeKey !== 'loading' && Boolean(id),
  });
}
